import React, {useMemo} from "react";
import {formatMoney} from "../../../../../../../../../core/services/utils/utils";
import Stepper from "../../../../../../../../components/app-specific/stepper";
import {NewBulkPriceChangeSteps} from "../../index";

const NewBulkPriceChangeViewStepperSection = ({state, setStep, updatingStep}) => {

    const steps = useMemo(() => {
        const result = [
            {id: NewBulkPriceChangeSteps.productSelection},
            {id: NewBulkPriceChangeSteps.priceLevelSelection},
            {id: NewBulkPriceChangeSteps.changePrice},
            {id: NewBulkPriceChangeSteps.reviewAndFinalize},
        ]
        const changedLabels = {
            [NewBulkPriceChangeSteps.productSelection]: `${state.totalAffectedParts ?? 0} Product${(state.totalAffectedParts ?? 0) === 1 ? '' : 's'} Selected`,
            [NewBulkPriceChangeSteps.priceLevelSelection]: `${state.affectedPriceLevels} price level${state.affectedPriceLevels === 1 ? '' : 's'} selected`,
            [NewBulkPriceChangeSteps.changePrice]: `${!state.isPercentage
                ? `${state.requestedAmount > 0 ? '+' : '-'}` + formatMoney(Math.abs(state.requestedAmount))
                : `${state.requestedAmount > 0 ? '+' : ''}` + state.requestedAmount?.toFixed(2) + '%'}`,
            [NewBulkPriceChangeSteps.reviewAndFinalize]: 'Review and Finalize',
        }
        const defaultLabels = {
            [NewBulkPriceChangeSteps.productSelection]: 'Select Products',
            [NewBulkPriceChangeSteps.priceLevelSelection]: 'Select Price Levels',
            [NewBulkPriceChangeSteps.changePrice]: 'Change Price',
            [NewBulkPriceChangeSteps.reviewAndFinalize]: 'Review and Finalize',
        }
        const stepsDisabledStatus = {
            [NewBulkPriceChangeSteps.productSelection]: false,
            [NewBulkPriceChangeSteps.priceLevelSelection]: !state.totalAffectedParts,
            [NewBulkPriceChangeSteps.changePrice]: !state.totalAffectedParts || !state.affectedPriceLevels,
            [NewBulkPriceChangeSteps.reviewAndFinalize]: !state.totalAffectedParts || !state.affectedPriceLevels,
        }
        return result.map(e => ({
            id: e.id,
            label: !stepsDisabledStatus[e.id] ? changedLabels[e.id] : defaultLabels[e.id],
            disabled: stepsDisabledStatus[e.id] || updatingStep,
        }));
    }, [state.affectedPriceLevels, state.isPercentage, state.requestedAmount, state.totalAffectedParts, updatingStep])

    return (
        <Stepper
            steps={steps}
            activeStepId={state.step}
            onClicked={setStep}
            className={'w-75 my-5'}
        />
    );
};

export default NewBulkPriceChangeViewStepperSection;
